import { render, staticRenderFns } from "./MyCheckBox.vue?vue&type=template&id=4008e340"
import script from "./MyCheckBox.vue?vue&type=script&lang=js"
export * from "./MyCheckBox.vue?vue&type=script&lang=js"
import style0 from "./MyCheckBox.vue?vue&type=style&index=0&id=4008e340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports